webpackJsonp([8],{

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(633),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17fbb784",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTjData;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTjDataFh;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(13);


function getTjData(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getTjData',
    data: data,
    method: 'get'
  });
}

function getTjDataFh(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: 'https://fh.mathmarch.com/api/serverInfo?token=fiberhome.2019',
    data: data,
    method: 'get'
  });
}

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api_tj_js__ = __webpack_require__(524);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      value: '',
      userCount: '',
      userProblemCount: '',
      loginUCToday: '',
      loginUCMonth: '',
      rechargeNum: '',
      consumeToday: '',
      consumeAll: '',
      shareToday: '',
      shareAll: '',
      onLineUserCount: '',
      roomCount: '',
      ppGameUsers: '',
      onLineUsers: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['welcome']), {
    getMsg: function getMsg() {
      return '用于对数学长征App的数据进行管理，包括审核题目、审核评论、查看统计报表等。';
    }
  }),
  mounted: function mounted() {},

  methods: {
    getTjInfo: function getTjInfo() {
      var _this = this;

      console.log('----------getTjInfo----');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api_tj_js__["a" /* getTjData */])().then(function (res) {
        if (res.data) {
          _this.userCount = '注册用户数：' + res.data.userCount;
          _this.userProblemCount = '用户新出题数：' + res.data.newUserProblemCount;
          _this.loginUCToday = '当日登陆不同用户数：' + res.data.loginUCToday;
          _this.loginUCMonth = '当月登陆不同用户数：' + res.data.loginUCMonth;
          _this.rechargeNum = '充值总数：' + res.data.rechargeNum;
          _this.consumeToday = '当日花费额(金币)：' + res.data.consumeToday;
          _this.consumeAll = '总花费额(金币)：' + res.data.consumeAll;
          _this.shareToday = '当日分享次数：' + res.data.shareToday;
          _this.shareAll = '总分享次数：' + res.data.shareAll;
        } else {}
      });
    },
    getTjInfoFh: function getTjInfoFh() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api_tj_js__["b" /* getTjDataFh */])().then(function (res) {
        if (res.data) {
          _this2.onLineUserCount = '在线用户数：' + res.data.onlineUsers.length;
          _this2.roomCount = '游戏房间数：' + res.data.rooms.length;
          _this2.ppGameUsers = '正在匹配用户数：' + res.data.ppGameUsers.length;
          var uNames = '';
          for (var i = 0; i < res.data.onlineUsers.length; i++) {
            if (i === 0) {
              uNames = res.data.onlineUsers[i].nick;
            } else {
              uNames = uNames + ',' + res.data.onlineUsers[i].nick;
            }
          }
          _this2.onLineUsers = '在线用户列表：' + uNames;
        } else {}
      });
    }
  }
});

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, ".centerdiv[data-v-17fbb784]{height:auto;text-align:center}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/pages/welcome.vue"],"names":[],"mappings":"AACA,4BACE,YAAa,AACb,iBAAmB,CACpB","file":"welcome.vue","sourcesContent":["\n.centerdiv[data-v-17fbb784]{\n  height: auto;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(566);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("48691bb9", content, true);

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centerdiv"
  }, [_c('h2', [_vm._v("《数学长征管理端》")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.getMsg)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getTjInfo
    }
  }, [_vm._v("刷新统计--数学长征")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('el-row', [_c('label', [_vm._v(_vm._s(_vm.userCount))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.rechargeNum))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.consumeToday))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.consumeAll))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.shareToday))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.shareAll))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.userProblemCount))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.loginUCToday))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.loginUCMonth))]), _c('br')])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getTjInfoFh
    }
  }, [_vm._v("刷新统计--烽火数学")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('el-row', [_c('label', [_vm._v(_vm._s(_vm.onLineUserCount))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.roomCount))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.ppGameUsers))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.onLineUsers))]), _c('br')])], 1)])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.5a16326db7bf7f1ff6d3.js